<script setup name="BaseDivideWrapper">
defineProps({
  withTopBorder: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="divide-y divide-charcoal-2"
    :class="{ 'border-t border-charcoal-2': withTopBorder }"
  >
    <slot />
  </div>
</template>
